export const getters = {
  getAgentsActive: state => state.agentsActive,
  getAgentsInvited: state => state.agentsInvited,
  getAgentsInactive: state => state.agentsInactive,
  getAgentsLoadingStatus: state => state.agentsLoadingStatus,
  getAgentDetails: state => state.agentDetails,
  getClients: state => state.clients,
  getClientsActionRequired: state => state.clientsActionRequired,
  getClientDetails: state => state.clientDetails,
  getAllAgentsActive: state => state.allAgentsActive,
  getRouteToRedirect: state => state.routeToRedirect,
};
